import type { Component, TimeAnimationOptions } from '@wix/thunderbolt-becky-types'
import type { FeatureRefs } from '../cssFeatures.types'
import { createCssCompNode } from '../cssCompNode'
import { hasResponsiveLayout } from '../../utils/hasResponsiveLayout'
import { envRefs, VariantRelationViewItem } from '@wix/thunderbolt-catharsis'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import { toCompVariants } from '../../utils/toCompVariants'
import { isVariantRelation } from '../../utils/variantsUtils'

function getMobileVariation(
	values: Array<TimeAnimationOptions | VariantRelationViewItem<TimeAnimationOptions>>
): TimeAnimationOptions | null {
	for (const value of values) {
		if (isVariantRelation(value) && value.variants.find((variant) => variant.type === 'Mobile')) {
			return value.to
		}
	}

	return values[0] as TimeAnimationOptions
}

export const motionEffects = createCssCompNode('motionEffects', 'motionEffects', {
	getDependencies: (component: Component, refs: FeatureRefs<'motionEffects'>) =>
		component.effectsQuery
			? {
					effectsData: refs.effectsQuery(component.effectsQuery),
					isMobileView: envRefs.isMobileView,
					showScreenInComp: envRefs.showScreenInComp,
					isMeshV2: envRefs.experiment('specs.thunderbolt.mesh2'),
			  }
			: null,

	toViewItem: (component, deps) => {
		if (!deps || deps.showScreenInComp) {
			return null
		}

		const { effectsData, isMobileView } = deps
		const effects = effectsData?.values

		if (!effects?.length) {
			return null
		}

		// TODO: REMOVE 'deps.isMeshV2' when hasResponsiveLayout supports mesh case
		const isResponsive = hasResponsiveLayout(component) && !deps.isMeshV2

		return effects
			.filter((effect) => effect.type === 'TimeAnimation')
			.map((effect) => ({
				variants: toCompVariants(effect.value.values),
				data: isResponsive
					? toBreakpointVariantsMap(effect.value.values, (x) => x)
					: {
							default: {
								'': isMobileView
									? getMobileVariation(effect.value.values)
									: (effect.value.values[0] as TimeAnimationOptions),
							},
					  },
			}))
	},
})
